export default "__VITE_ASSET__rmv8UgTR__"